import { gql } from '@apollo/client'
import { scoreGridFragment } from './fragments/scoreGridFragment'
import { ScoreGridsOverviewFragment } from './fragments/scoreGridsOverviewFragment'

export const SCORE_GRID_QUERY = gql`
  query scoreGridWithHistory($meetingId: HashedId!, $employeeId: HashedId!, $country: Country!) {
    scoreGridWithHistory(meetingId: $meetingId, employeeId: $employeeId) {
      ...ScoreGridFragment
    }
    isIdVWeightEnabled(country: $country)
  }

  ${scoreGridFragment}
`

export const SCORE_GRIDS_OVERVIEW_QUERY = gql`
  query evaluationFromLastTwoAppraisals($employeeId: HashedId!) {
    evaluationFromLastTwoAppraisals(employeeId: $employeeId) {
      ...ScoreGridsOverviewFragment
    }
  }
  ${ScoreGridsOverviewFragment}
`
